import { render, staticRenderFns } from "./ProductTagList.vue?vue&type=template&id=cce07c6e&scoped=true&"
import script from "./ProductTagList.vue?vue&type=script&lang=js&"
export * from "./ProductTagList.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagList.vue?vue&type=style&index=0&id=cce07c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce07c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cce07c6e')) {
      api.createRecord('cce07c6e', component.options)
    } else {
      api.reload('cce07c6e', component.options)
    }
    module.hot.accept("./ProductTagList.vue?vue&type=template&id=cce07c6e&scoped=true&", function () {
      api.rerender('cce07c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/ProductTagList.vue"
export default component.exports